module.exports = __webpack_public_path__ + "static/img/yjyp.556ec518.png";